// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"443":"about","517":"page-dashboard","637":"page-admin-index"}[chunkId] || chunkId) + "." + {"349":"196db466","361":"eb7a828d","443":"5b212978","517":"26b19a38","634":"ca901b12","637":"2dfd2b1f"}[chunkId] + ".css";
};